import axios from 'axios'

export default {
    redeem(code) {
        return axios.post('discount/redeem', {
            code:code
        })
    }
}
